export default __webpack_public_path__ + "static/media/water.cceb486f.svg";